import { CryptoCurrencyTypes } from "app/utils/const";
import cx from "classnames";
import IconBitcoin from "./components/IconBitcoin/IconBitcoin";
import IconBitcoinCash from "./components/IconBitcoinCash/IconBitcoinCash";
import IconEthereum from "./components/IconEthereum/IconEthereum";
import IconTether from "./components/IconTether/IconTether";
import "./IconCrypto.scss";

type Props = {
  name: string;
  className?: string;
};

const IconCrypto = (props: Props): any => {
  let { name, className } = props;
  const newProps = {
    className: cx("icon-crypto", className),
  };

  switch (name) {
    case CryptoCurrencyTypes.BTC:
      return <IconBitcoin {...newProps} />;
    case CryptoCurrencyTypes.BCH:
      return <IconBitcoinCash {...newProps} />;
    case CryptoCurrencyTypes.USDT_ERC20:
      return <IconTether {...newProps} />;
    case CryptoCurrencyTypes.USDT_TRC20:
      return <IconTether {...newProps} />;
    case CryptoCurrencyTypes.ETH:
      return <IconEthereum {...newProps} />;

    default:
      console.error("No crypto icon for: ", name);
      return null;
  }
};

export default IconCrypto;
